module.exports = "<div ncy-breadcrumb></div> <div class=r> <div class=\"c w-lg-2-3 w-xl-3-4 w-xx-7-12\"> <h1> <div>Uw verzending is geregistreerd</div> </h1> <div class=\"box box-border box-border-primary\"> <div class=box-body> <h5 class=m-b-0>Print de verzendlabels en geef de pakjes mee met uw Febelco chauffeur.</h5> <p> Een woordje uitleg wat men nu moet doen ... Text TBD </p> </div> </div> </div> </div> <order-detail-content order=vm.order confirmation=true></order-detail-content>";


//////////////////
// WEBPACK FOOTER
// ./features/account/my-packages/pod-order-add-confirmation.html
// module id = 534
// module chunks = 0